import styled, { css } from 'styled-components'

export const Button = styled.button`
    ${({ outline, customHeight, customWidth }) => css`
        padding: 10px 21px;
        border-radius: 99px;
        background-color: ${outline ? 'var(--the-white)' : 'var(--cobasi-blue-light-9)'};
        border: 1px solid var(--cobasi-blue-light-9);
        color: ${!outline ? 'var(--the-white)' : 'var(--cobasi-blue-light-9)'};
        font-family: var(--primary-font);
        font-weight: 600;
        width: ${customWidth ?? '100%'};
        cursor: pointer;
        transition: 0.3s;
        font-size: 16px;
        ${customHeight && `height: ${customHeight};`}
        :hover {
            opacity: 0.7;
            transition: 0.3s;
        }

        :active {
            opacity: 0.5;
            transition: 0.3s;
        }

        :disabled {
            opacity: 0.2;
        }
    `}
`
